import { SUCCESS } from '../../../../../constants/action-postfix'
import { EDU_COMMISSIONS_GET_REQUEST } from '../../eduCommissionsActionTypes'

const initialState = []

export const eduCommissionsMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${EDU_COMMISSIONS_GET_REQUEST}${SUCCESS}`:
      return action.payload?.members || []

    default:
      return state
  }
}
